import { GridCustomCellProps } from '@progress/kendo-react-grid';
import dayjs from 'dayjs';
import * as React from 'react';
import { Trip } from '.';
import Positions from './TripPositions';

const PositionCell = (props: GridCustomCellProps) => {
  const [showPositions, setShowPositions] = React.useState(false);
  const trip = props.dataItem as Trip;
  return <td {...props.tdProps}>
    {showPositions && <Positions tripId={trip.TripID} close={() => setShowPositions(false)} />}
    {trip.PositionDateTime ? <>
      <a
        href="#"
        style={{ color: (trip.NeedsCheckCall && trip.OrderStopStatus != 115 ? 'red' : '#007bff') }}
        onClick={(e) => {
          setShowPositions(true);
          e.preventDefault();
        }}
      >
        {dayjs.utc(trip.PositionDateTime).tz("America/New_York").format('MM/DD/YYYY HH:mm')}
      </a><br />
      <span
        style={{ color: (trip.PositionRepeatCount >= 7 ? 'red' : '#007bff') }}
      >
        {trip.PositionLocation}
        {trip.PositionRepeatCount > 1 && ` (${trip.PositionRepeatCount}x)`}
      </span>
    </> : trip.TripID ? <a href="#"
        style={{ color: (trip.NeedsCheckCall && trip.OrderStopStatus != 115 ? 'red' : '#007bff') }}
        onClick={(e) => {
          setShowPositions(true);
          e.preventDefault();
        }}
      >
        No Position
      </a> : null}
    {trip.CarrierThreadID && <>
      <br />
      <a
        style={{ color: '#007bff' }}
        href={`https://app.frontapp.com/open/${trip.CarrierThreadID}`}
        target="_blank"
        rel="noopener noreferrer"
      >
        {trip.CarrierThreadLastEmailedDateTime ? 'Emailed ' + dayjs.utc(trip.CarrierThreadLastEmailedDateTime).fromNow() : 'Email Carrier'}
      </a>
    </>}
  </td>
}

export default React.memo(PositionCell, (prev, next) => prev.dataItem.Hash === next.dataItem.Hash);
